import { render, staticRenderFns } from "./CreatePlanning.vue?vue&type=template&id=3512bbc7&"
import script from "./CreatePlanning.vue?vue&type=script&lang=ts&"
export * from "./CreatePlanning.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePlanning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports